import {
  genericCreate,
  genericFind,
  genericGet,
  genericRemove,
} from '@/services/common';

import update from './update';

export const create = genericCreate('material');

export const find = genericFind('material');

export const get = genericGet('material');

export const remove = genericRemove('material');

export * from './types';

export default {
  create,
  find,
  get,
  remove,
  update,
};
